<template>
    <page
        :showBackButton="true"
        defaultHref="/services/schadensmeldung"
        ref="page"
    >
        <contract-card
            v-if="contractIdForCard !== ''"
            :contractId="contractIdForCard"
            :feature="feature"
            :shouldPresentContractSwitcherModal="
                shouldPresentContractSwitcherModal
            "
        ></contract-card>
        <h1>Schadensmeldung Haushalt</h1>
        <form @submit.prevent="submitForm()">
            <stepper v-model="formData.formstep" :count="stepCount">
                <stepper-item class="u-form-p-bottom" :step="1">
                    <ion-card class="-light">
                        <base-input
                            id="polizzenversicherung"
                            v-model="formData.polizzenversicherung"
                            type="text"
                            label="Polizzen-Nr. HH / EH-Versicherung"
                        ></base-input>
                    </ion-card>
                    <personal-data
                        :geschlecht.sync="formData.geschlecht"
                        :titel.sync="formData.titel"
                        :vorname.sync="formData.vorname"
                        :zuname.sync="formData.zuname"
                        :strasse.sync="formData.strasse"
                        :hausnr.sync="formData.hausnr"
                        :stiege.sync="formData.stiege"
                        :stock.sync="formData.stock"
                        :tuer.sync="formData.tuer"
                        :plz.sync="formData.plz"
                        :ort.sync="formData.ort"
                        :email.sync="formData.email"
                        :telefon.sync="formData.telefon"
                        :geburtsdatum.sync="formData.geburtsdatum"
                        suffix=" *"
                    ></personal-data>
                    <ion-button
                        expand="block"
                        class="ion-margin-top ion-margin-bottom"
                        @click="submitForm()"
                        >Weiter</ion-button
                    >
                </stepper-item>
                <stepper-item class="u-form-p-bottom" :step="2">
                    <ion-card class="-light">
                        <ion-grid>
                            <ion-row>
                                <ion-col size="12">
                                    <base-select
                                        v-model="formData.ereignis"
                                        id="ereignis"
                                        label="Ereignis"
                                    >
                                        <ion-select-option value="Haftpflicht"
                                            >Haftpflicht</ion-select-option
                                        >
                                        <ion-select-option
                                            value="Glasbruch/Glasschaden"
                                            >Glasbruch/Glasschaden</ion-select-option
                                        >
                                        <ion-select-option value="Feuer"
                                            >Feuer</ion-select-option
                                        >
                                        <ion-select-option value="Sturm"
                                            >Sturm</ion-select-option
                                        >
                                        <ion-select-option value="Hagel"
                                            >Hagel</ion-select-option
                                        >
                                        <ion-select-option value="Erdrutsch"
                                            >Erdrutsch</ion-select-option
                                        >
                                        <ion-select-option
                                            value="Überschwemmung"
                                            >Überschwemmung</ion-select-option
                                        >
                                        <ion-select-option
                                            value="Leitungswasser"
                                            >Leitungswasser</ion-select-option
                                        >
                                        <ion-select-option
                                            value="Einbruchdiebstahl"
                                            >Einbruchdiebstahl</ion-select-option
                                        >
                                        <ion-select-option value="Sonstiges"
                                            >Sonstiges</ion-select-option
                                        >
                                    </base-select>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ion-card>
                    <accident-data
                        :unfallDatum.sync="formData.unfallDatum"
                        :unfallUhrzeit.sync="formData.unfallUhrzeit"
                        :unfallStrasse.sync="formData.unfallStrasse"
                        :unfallHausnr.sync="formData.unfallHausnr"
                        :unfallStiege.sync="formData.unfallStiege"
                        :unfallStock.sync="formData.unfallStock"
                        :unfallTuer.sync="formData.unfallTuer"
                        :unfallPlz.sync="formData.unfallPlz"
                        :unfallOrt.sync="formData.unfallOrt"
                        :unfallLand.sync="formData.unfallLand"
                        :unfallBeschreibung.sync="formData.unfallBeschreibung"
                        @place-is-home-address="fillPlaceData()"
                    ></accident-data>
                    <ion-row class="ion-margin-top ion-margin-bottom">
                        <ion-col size="6">
                            <ion-button
                                expand="block"
                                @click="stepBack()"
                                fill="outline"
                                >Zurück</ion-button
                            >
                        </ion-col>
                        <ion-col size="6">
                            <ion-button expand="block" @click="submitForm()"
                                >Weiter</ion-button
                            >
                        </ion-col>
                    </ion-row>
                </stepper-item>
                <stepper-item class="u-form-p-bottom" :step="3">
                    <ion-card class="-light">
                        <ion-list-header
                            >Was ist vom Schaden betroffen?</ion-list-header
                        >
                        <ion-grid>
                            <ion-row>
                                <ion-col>
                                    <ion-list>
                                        <ion-item>
                                            <base-checkbox
                                                v-model="
                                                    formData.schadenGebaeude
                                                "
                                                id="schaden-gebaeude"
                                            ></base-checkbox>
                                            <ion-label>Gebäude</ion-label>
                                        </ion-item>
                                        <ion-item>
                                            <base-checkbox
                                                v-model="
                                                    formData.schadenEinrichtung
                                                "
                                                id="schaden-einrichtung"
                                            ></base-checkbox>
                                            <ion-label>Einrichtung</ion-label>
                                        </ion-item>
                                        <ion-item>
                                            <base-checkbox
                                                v-model="
                                                    formData.schadenWarenlager
                                                "
                                                id="schaden-warenlager"
                                            ></base-checkbox>
                                            <ion-label>Warenlager</ion-label>
                                        </ion-item>
                                        <ion-item>
                                            <base-checkbox
                                                v-model="
                                                    formData.schadenBargeld
                                                "
                                                id="schaden-bargeld"
                                            ></base-checkbox>
                                            <ion-label>Bargeld</ion-label>
                                        </ion-item>
                                        <ion-item>
                                            <base-checkbox
                                                v-model="
                                                    formData.schadenWertgegenstaende
                                                "
                                                id="schaden-wertgegenstaende"
                                            ></base-checkbox>
                                            <ion-label
                                                >Wertgegenstände</ion-label
                                            >
                                        </ion-item>
                                    </ion-list>
                                </ion-col>
                            </ion-row>
                            <ion-row>
                                <ion-col>
                                    <base-textarea
                                        id="schaden-sonstiger"
                                        v-model="formData.schadenSonstiger"
                                        label="Sonstiger Schaden?"
                                    ></base-textarea>
                                </ion-col>
                            </ion-row>
                            <ion-row>
                                <ion-col>
                                    <base-number-input
                                        v-model="formData.gesamtkostenaufwand"
                                        label="Gesamtkostenaufwand"
                                        id="schaden-hoehe"
                                    ></base-number-input>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ion-card>
                    <ion-card class="-light">
                        <ion-list-header>Schadensfotos</ion-list-header>
                        <ion-grid>
                            <ion-row>
                                <ion-col>
                                    <files-upload
                                        class="ion-margin-bottom"
                                        v-model="formData.schadensfotos"
                                        :multiple="true"
                                        id="schadensfotos"
                                    ></files-upload>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ion-card>
                    <ion-grid>
                        <ion-row class="ion-margin-top ion-margin-bottom">
                            <ion-col size="6">
                                <ion-button
                                    expand="block"
                                    @click="stepBack()"
                                    fill="outline"
                                    >Zurück</ion-button
                                >
                            </ion-col>
                            <ion-col size="6">
                                <ion-button expand="block" @click="submitForm()"
                                    >Absenden</ion-button
                                >
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </stepper-item>
            </stepper>
        </form>
    </page>
</template>

<script>
import Page from "@/components/Page";
import PersonalData from "@/components/PersonalData";
import Stepper from "@/components/Stepper";
import StepperItem from "@/components/StepperItem";
import BaseSelect from "@/components/BaseSelect";
import BaseInput from "@/components/BaseInput";
import AccidentData from "@/components/AccidentData";
import BaseNumberInput from "@/components/BaseNumberInput";
import BaseTextarea from "@/components/BaseTextarea";
import BaseCheckbox from "@/components/BaseCheckbox";
import { schadensmeldung } from "@/mixins/schadensmeldung";
import FilesUpload from "@/components/FilesUpload";
import ContractCard from "@/components/ContractCard";

export default {
    mixins: [schadensmeldung],
    components: {
        Page,
        PersonalData,
        Stepper,
        StepperItem,
        BaseSelect,
        BaseInput,
        AccidentData,
        BaseNumberInput,
        BaseTextarea,
        BaseCheckbox,
        FilesUpload,
        ContractCard,
    },
    data() {
        return {
            stepCount: 3,
            feature: "SchadensmeldungHaushalt",
            formData: {
                mode: "haushalt",
                formstep: 1,
                polizzenversicherung: "",
                geschlecht: "",
                titel: "",
                vorname: "",
                zuname: "",
                strasse: "",
                hausnr: "",
                stiege: "",
                stock: "",
                tuer: "",
                plz: "",
                ort: "",
                email: "",
                telefon: "",
                ereignis: "",
                geburtsdatum: "",
                unfallDatum: "",
                unfallUhrzeit: "",
                unfallStrasse: "",
                unfallHausnr: "",
                unfallStiege: "",
                unfallStock: "",
                unfallTuer: "",
                unfallPlz: "",
                unfallOrt: "",
                unfallLand: "",
                unfallBeschreibung: "",
                schadenGebaeude: false,
                schadenEinrichtung: false,
                schadenWarenlager: false,
                schadenBargeld: false,
                schadenWertgegenstaende: false,
                schadenSonstiger: "",
                gesamtkostenaufwand: "",
                schadensfotos: [],
            },
        };
    },
};
</script>

<style></style>
